import script from "./TaskForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskForm.vue?vue&type=script&setup=true&lang=js"

import "./TaskForm.vue?vue&type=style&index=0&id=115a9358&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115a9358"]])

export default __exports__